import * as invoicing from './invoicing';
import * as kanban from './kanban';
import * as orders from './orders';
import * as stockDownload from './stockDownload';
import * as techniciansAssignment from './techniciansAssignment';
import * as timeMarked from './timeMarked';

const reducers = {
  ...invoicing,
  ...kanban,
  ...orders,
  ...stockDownload,
  ...techniciansAssignment,
  ...timeMarked,
};

export default reducers;
